import React from "react";

import { ProductMarketplaceCategory } from "custom-types/Product";

import Breadcrumb from "components/Breadcrumb";
import Breadcrumbs from "components/Breadcrumbs";

export const ProductBreadcrumbs: React.FC<{
  category?: ProductMarketplaceCategory;
  subcategory?: ProductMarketplaceCategory;
}> = ({ category, subcategory }) => (
  <Breadcrumbs useWhiteBackground={false} className="-mx-lg">
    <Breadcrumb
      href={category ? "/products" : undefined}
      currentLocation={!category && !subcategory}
    >
      Shop
    </Breadcrumb>
    {category && (
      <Breadcrumb
        href={subcategory ? `/products/${category.slug}` : undefined}
        currentLocation={!subcategory}
      >
        {category.name}
      </Breadcrumb>
    )}
    {category && subcategory && (
      <Breadcrumb currentLocation={true}>{subcategory.name}</Breadcrumb>
    )}
  </Breadcrumbs>
);
